import { useTranslation } from 'react-i18next'

const SchoolCorridor = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="school-corridor-title"
      xmlSpace="preserve"
      {...props}
    >
      <title id="school-corridor-title">{t('antagonists:classmate2:components:background')}</title>
      <defs>
        <clipPath id="school-corridor-b">
          <path
            style={{
              fill: 'none',
            }}
            d="M0 0h1920v1080H0z"
          />
        </clipPath>
        <clipPath id="school-corridor-c">
          <path
            style={{
              fill: '#fbbf1f',
            }}
            d="m836.11 335.71-1.54 89.8 91.61-.58 1.19-89.71-91.26.49z"
          />
        </clipPath>
        <clipPath id="school-corridor-d">
          <path
            d="M125.78 40.87s1.03 24.82 2.07 32.06c1.03 7.24 3.1 11.37 21.72 12.41 18.61 1.03 563.57 3.1 585.28 3.1s33.09-7.24 34.12-16.55C770 62.58 770 43.97 770 43.97l-644.23-3.1Z"
            style={{
              fill: '#ffed00',
            }}
          />
        </clipPath>
        <clipPath id="school-corridor-e">
          <path
            d="M1062.58 40.87s1.03 24.82 2.07 32.06c1.03 7.24 3.1 11.37 21.72 12.41 18.61 1.03 563.57 3.1 585.28 3.1s33.09-7.24 34.12-16.55c1.03-9.31 1.03-27.92 1.03-27.92l-644.23-3.1Z"
            style={{
              fill: '#ffed00',
            }}
          />
        </clipPath>
        <clipPath id="school-corridor-f">
          <path
            d="M973.96 801.87c2.79 9.53 2.8 58.55 1.64 69-1.16 10.45-7.88 75.9-19.99 89.66-3.21 3.64-30.41 2.65-42.47.48-12.06-2.17-53.8-17.06-59.66-23.29-6.77-7.19 10.11-114.01 12.42-123.77 2.31-9.76 7.37-9.71 9.96-14.87 2.59-5.16 4.5-20.3 20.93-21.74 16.43-1.43 42.76 2.77 52.14 4.26 9.38 1.49 23.55 15.22 25.03 20.27Z"
            style={{
              fill: '#e37a37',
            }}
          />
        </clipPath>
        <style>
          {
            '.h{fill:none}.i{fill:#eeeef0}.j{fill:#f5ac7b}.k{fill:#fbbf1f}.l{fill:#e8e9dd}.m{fill:#e2e6ea}.n{fill:#ffed00}.o{fill:#f1f1f3}.p{fill:#7e897b}.q{fill:#b591be}.r{fill:#32343c}.s{fill:#cdc3b0}.t{fill:#cad3cc}.u{fill:#c4c7c9}.v{fill:#e37a37}.w{fill:#b39746}.x{fill:#3fa25a}.y{fill:#54535e}.aa{fill:#2da4bd}.ab{fill:#70847a}.ac{fill:#75c6cf}.ad{fill:#70a25e}.ae{fill:#7b408e}.af{clip-path:url(#school-corridor-c)}.ag{clip-path:url(#school-corridor-b)}.ah{clip-path:url(#school-corridor-f)}.ai{clip-path:url(#school-corridor-e)}.aj{clip-path:url(#school-corridor-d)}'
          }
        </style>
      </defs>
      <g
        style={{
          clipPath: 'url(#school-corridor-b)',
        }}
        id="school-corridor-a"
      >
        <path
          style={{
            fill: '#cad3cc',
          }}
          d="m1983 1156.86-2099.44 15.76 2.82-1262.51 2099.44-15.77-2.82 1262.52z"
        />
        <path
          id="ENVIRONMENT_BACKGROUND"
          style={{
            fill: '#e8e9dd',
          }}
          d="m-245.13 817.38 2331.25-.58-35.75 426.96-2270.89 140.29-24.61-566.67z"
        />
        <path
          style={{
            fill: '#b39746',
          }}
          d="m-51.6 288.89 465.93 1.71-1.65 50.13-460.65-.89-3.63-50.95z"
        />
        <path
          style={{
            fill: '#e2e6ea',
          }}
          d="m346.04 238.34-18.48 50.69 2.84 53.53 11.85 8.06 10.42-.47 9.95-18.48-10.43-2.84-6.15 11.37-3.32-50.7 13.74-40.74 3.31 13.26 11.38-.47-6.64-22.27-18.47-.94z"
        />
        <path
          d="M338.71 296.64c-2.76.69-2.88 3.2-2.67 4.91s1.71 2.78 3.2 2.67 2.56-1.49 2.56-4.27-1.39-3.74-3.1-3.31ZM340.1 319.8c-2.76.69-2.88 3.2-2.67 4.91s1.71 2.78 3.2 2.67c1.49-.11 2.56-1.49 2.56-4.27s-1.39-3.74-3.1-3.31Z"
          style={{
            fill: '#313e36',
          }}
        />
        <path
          style={{
            fill: '#e2e6ea',
          }}
          d="m190.32 238.34-18.47 50.69 2.84 53.53 11.84 8.06 10.43-.47 9.95-18.48-10.43-2.84-6.16 11.37-3.31-50.7 13.74-40.74 3.31 13.26 11.37-.47-6.63-22.27-18.48-.94z"
        />
        <path
          d="M183 296.64c-2.76.69-2.88 3.2-2.67 4.91s1.71 2.78 3.2 2.67 2.56-1.49 2.56-4.27-1.39-3.74-3.1-3.31ZM184.39 319.8c-2.76.69-2.88 3.2-2.67 4.91s1.71 2.78 3.2 2.67c1.49-.11 2.56-1.49 2.56-4.27s-1.39-3.74-3.1-3.31Z"
          style={{
            fill: '#313e36',
          }}
        />
        <path
          style={{
            fill: '#e2e6ea',
          }}
          d="m112.47 238.34-18.48 50.69 2.84 53.53 11.85 8.06 10.42-.47 9.95-18.48-10.42-2.84-6.16 11.37-3.32-50.7 13.74-40.74 3.32 13.26 11.37-.47-6.63-22.27-18.48-.94z"
        />
        <path
          d="M105.14 296.64c-2.76.69-2.88 3.2-2.67 4.91s1.71 2.78 3.2 2.67 2.56-1.49 2.56-4.27-1.39-3.74-3.1-3.31ZM106.53 319.8c-2.76.69-2.88 3.2-2.67 4.91s1.71 2.78 3.2 2.67c1.49-.11 2.56-1.49 2.56-4.27s-1.39-3.74-3.1-3.31Z"
          style={{
            fill: '#313e36',
          }}
        />
        <path
          style={{
            fill: '#e2e6ea',
          }}
          d="m268.18 238.34-18.48 50.69 2.85 53.53 11.84 8.06 10.42-.47 9.95-18.48-10.42-2.84-6.16 11.37-3.32-50.7 13.74-40.74 3.32 13.26 11.37-.47-6.63-22.27-18.48-.94z"
        />
        <path
          d="M260.85 296.64c-2.76.69-2.88 3.2-2.67 4.91s1.71 2.78 3.2 2.67 2.56-1.49 2.56-4.27-1.39-3.74-3.1-3.31ZM262.24 319.8c-2.76.69-2.88 3.2-2.67 4.91s1.71 2.78 3.2 2.67c1.49-.11 2.56-1.49 2.56-4.27s-1.39-3.74-3.1-3.31Z"
          style={{
            fill: '#313e36',
          }}
        />
        <path
          style={{
            fill: '#54535e',
          }}
          d="M801.52 309.86V527.8h169.9l-1.98-218.14-167.92.2z"
        />
        <path
          style={{
            fill: '#eeeef0',
          }}
          d="m810.27 321.94.05 194.66 149.56-.85L959 321.6l-148.73.34z"
        />
        <path
          style={{
            fill: '#c4c7c9',
          }}
          d="m833.98 448.89.9 10.49 61.57.04-.04-10.53h-62.43zM834.5 470.07l-.04 10.5 103.54.07-.21-10.21-103.29-.36z"
        />
        <path
          style={{
            fill: '#fbbf1f',
          }}
          d="m836.11 335.71-1.54 89.8 91.61-.58 1.19-89.71-91.26.49z"
        />
        <g
          style={{
            clipPath: 'url(#school-corridor-c)',
          }}
        >
          <path
            d="m870.74 431.74-9.12-34.69s3.04-43.3 3.04-46.59 8.1-7.6 8.61.51c.51 8.1.76 23.04.76 23.04s7.09-1.01 10.63 1.27 7.85 1.27 11.39 3.29c3.54 2.03 8.1 2.79 10.13 5.32 2.03 2.53 0 24.31-1.27 29.37-1.27 5.06-4.81 15.95-4.81 15.95s-28.61 2.53-29.37 2.53Z"
            style={{
              fill: '#ffed00',
            }}
          />
        </g>
        <path
          d="M125.78 40.87s1.03 24.82 2.07 32.06c1.03 7.24 3.1 11.37 21.72 12.41 18.61 1.03 563.57 3.1 585.28 3.1s33.09-7.24 34.12-16.55C770 62.58 770 43.97 770 43.97l-644.23-3.1Z"
          style={{
            fill: '#ffed00',
          }}
        />
        <g
          style={{
            clipPath: 'url(#school-corridor-d)',
          }}
        >
          <path
            style={{
              fill: '#f1f1f3',
            }}
            d="m103.36 56.44 722.81 3.1L821 4.73 101.29 8.87l2.07 47.57z"
          />
        </g>
        <path
          d="M1062.58 40.87s1.03 24.82 2.07 32.06c1.03 7.24 3.1 11.37 21.72 12.41 18.61 1.03 563.57 3.1 585.28 3.1s33.09-7.24 34.12-16.55c1.03-9.31 1.03-27.92 1.03-27.92l-644.23-3.1Z"
          style={{
            fill: '#ffed00',
          }}
        />
        <g
          style={{
            clipPath: 'url(#school-corridor-e)',
          }}
        >
          <path
            style={{
              fill: '#f1f1f3',
            }}
            d="m1038.8 60.52 722.82 3.1-5.18-54.81-719.71 4.14 2.07 47.57z"
          />
        </g>
        <path
          d="M1002.25 839.56c-2.64 13.55-9.92 66.11-18.58 79.17-8.66 13.05-34.08 26.19-34.08 26.19l-2.78-9.92s23.96-12.12 32.34-25.64c4.12-6.64 11.75-61.38 13.38-74.79 1.63-13.41-4.63-21.91-12.36-23.28-5.99-1.06-22.92-.88-22.92-.88l-1.06-8.78s19.02-1.12 28.44.84c10.8 2.25 20.53 22.15 17.62 37.1Z"
          style={{
            fill: '#e37a37',
          }}
        />
        <path
          d="M954.96 786.81s5.74-18.41 0-21.61c-5.55-3.1-25.97-6.12-29.22-1.57-3.26 4.55-6.34 16.56-6.34 16.56l9.62 2.09s-.74-14.8 1.29-15.46c4.43-1.44 19.29 1.07 21.1 2.38 1.82 1.3-3.86 17.24-3.86 17.24l7.4.39Z"
          style={{
            fill: '#7b408e',
          }}
        />
        <path
          d="M973.96 801.87c2.79 9.53 2.8 58.55 1.64 69-1.16 10.45-7.88 75.9-19.99 89.66-3.21 3.64-30.41 2.65-42.47.48-12.06-2.17-53.8-17.06-59.66-23.29-6.77-7.19 10.11-114.01 12.42-123.77 2.31-9.76 7.37-9.71 9.96-14.87 2.59-5.16 4.5-20.3 20.93-21.74 16.43-1.43 42.76 2.77 52.14 4.26 9.38 1.49 23.55 15.22 25.03 20.27Z"
          style={{
            fill: '#e37a37',
          }}
        />
        <g
          style={{
            clipPath: 'url(#school-corridor-f)',
          }}
        >
          <path
            d="M866.9 801.02s7.67-1.06 31.36 1.73c23.69 2.79 29.32 12.5 31.16 25.51 1.84 13.01-16.07 137.94-16.07 137.94l5.62-.61s16.76-119.29 14.96-140.78c-1.8-21.49-22.83-24.9-35.34-26.24s-32.48-2.89-32.48-2.89l.78 5.34Z"
            style={{
              fill: '#f5ac7b',
            }}
          />
          <path
            d="M967.11 921.48s-37.18-6.45-44.58-7.71c-13.43-2.28-26.62-4.14-49.2-11.78-22.58-7.65-29.56-14.89-29.56-14.89l-6.73 53.37 122.15 40.77 7.91-59.76Z"
            style={{
              fill: 'none',
            }}
          />
        </g>
        <path
          style={{
            fill: '#54535e',
          }}
          d="m1018.27 864.57-1.62 95.59 800.65-.4-.6-115.45-798.43 20.26z"
        />
        <path
          style={{
            fill: '#f1f1f3',
          }}
          d="m985.91 193.65 8.96 723.53 845.06-2.97-2.39-717.72-851.63-2.84z"
        />
        <path
          style={{
            fill: '#75c6cf',
          }}
          d="m1004.04 216.96 3.51 669.52h149.37l-1.53-668.2-151.35-1.32z"
        />
        <path
          style={{
            fill: '#ffed00',
          }}
          d="m1175.94 218.72 3.49 666.89 151.68 2.63-2.29-671.28-152.88 1.76z"
        />
        <path
          style={{
            fill: '#2da4bd',
          }}
          d="m1343.41 218.72 3.51 669.52h149.37V216.96l-152.88 1.76z"
        />
        <path
          style={{
            fill: '#b591be',
          }}
          d="m1508.06 218.72 3.52 669.52h149.36V216.96l-152.88 1.76z"
        />
        <path
          style={{
            fill: '#70a25e',
          }}
          d="m1673.16 220.31 2.37 662.66h149.37l1.14-664.42-152.88 1.76z"
        />
        <path
          d="m1187.09 579.26-4.13-.11c0-.12.25-11.83.32-14.55.08-2.94 1.33-5.93 3.36-7.99 1.55-1.57 4.28-3.38 8.55-3.06 6.19.45 9.9 4.45 10.46 11.27.33 4 .23 13.54.22 13.94l-4.13-.06c0-.1.1-9.7-.21-13.46-.37-4.53-2.47-6.78-6.61-7.08-2.23-.16-4.13.48-5.5 1.87-1.43 1.45-1.98 3.39-2.01 4.71-.07 2.7-.32 14.4-.32 14.52Z"
          style={{
            fill: '#70847a',
          }}
        />
        <path
          style={{
            fill: '#3fa25a',
          }}
          d="m1180.44 574.68-.32 25.26 27.85.11.1-24.78-27.63-.59z"
        />
        <path
          d="m1685.46 575.64-4.31-.1c0-.11.26-11.06.33-13.6.08-2.75 1.39-5.54 3.51-7.47 1.61-1.47 4.47-3.15 8.92-2.86 6.46.42 10.34 4.16 10.91 10.53.34 3.74.24 12.65.23 13.03l-4.31-.05c0-.09.11-9.06-.21-12.58-.38-4.23-2.58-6.33-6.9-6.62-2.33-.15-4.31.45-5.74 1.75-1.49 1.36-2.06 3.16-2.1 4.4-.07 2.53-.33 13.46-.33 13.57Z"
          style={{
            fill: '#cdc3b0',
          }}
        />
        <path
          style={{
            fill: '#32343c',
          }}
          d="m1678.51 571.36-.33 23.6 29.06.12.11-23.17-28.84-.55z"
        />
        <path
          d="m1044.18 581.03-4.27.33c0-.12-.95-12.31-1.6-16.61-1.08-7.15-6.16-6.8-7.83-6.68-5.66.39-6.87 5.12-6.72 7.86.16 2.78 1.67 15.21 1.69 15.33l-4.25.52c-.06-.52-1.55-12.69-1.71-15.61-.45-7.96 5.22-11.99 10.7-12.37 6.79-.47 11.29 3.29 12.36 10.32.67 4.46 1.6 16.41 1.64 16.92Z"
          style={{
            fill: '#ffed00',
          }}
        />
        <path
          style={{
            fill: '#7e897b',
          }}
          d="m1018.6 578.36 3.3 28.91 27.54-3.15-3.68-28.45-27.16 2.69z"
        />
        <path
          d="m1372.05 584.75-4.16-1c.03-.12 2.88-12 3.59-16.3 1.17-7.14-3.77-8.36-5.39-8.77-5.5-1.37-8.12 2.76-8.81 5.41-.71 2.69-3.09 14.98-3.11 15.11l-4.2-.81c.1-.51 2.43-12.55 3.17-15.38 2.02-7.71 8.65-9.81 13.99-8.48 6.61 1.64 9.73 6.6 8.58 13.62-.73 4.45-3.53 16.11-3.65 16.6Z"
          style={{
            fill: '#cdc3b0',
          }}
        />
        <path
          style={{
            fill: '#ffed00',
          }}
          d="m1348.54 574.34-5.76 28.53 27.17 5.47 5.25-28.2-26.66-5.8z"
        />
        <path
          d="m1535.01 579.32-3.44-.59c.02-.1 1.68-9.92 2.02-13.45.56-5.87-3.52-6.59-4.86-6.83-4.55-.81-6.45 2.69-6.87 4.88-.43 2.23-1.69 12.35-1.7 12.46l-3.46-.43c.05-.42 1.29-10.34 1.73-12.68 1.22-6.38 6.49-8.45 10.91-7.66 5.46.97 8.28 4.84 7.73 10.6-.35 3.66-1.98 13.29-2.05 13.7Z"
          style={{
            fill: '#c4c7c9',
          }}
        />
        <path
          style={{
            fill: '#c4c7c9',
          }}
          d="m1515.33 572.15-3.12 23.51 22.4 2.96 2.72-23.22-22-3.25z"
        />
        <path
          d="M1031.45 551.56c-5.29-.85-9.07 2.29-9.89 6.04-.82 3.75.68 8.85 5.74 10.06 5.06 1.21 9.88-2.68 10.52-6.47s-1.08-8.78-6.37-9.63ZM1196.02 551.56c-5.29-.85-9.07 2.29-9.89 6.04-.82 3.75.68 8.85 5.74 10.06 5.06 1.21 9.88-2.68 10.52-6.47.64-3.79-1.08-8.78-6.37-9.63ZM1366.23 551.56c-5.29-.85-9.07 2.29-9.89 6.04-.82 3.75.68 8.85 5.74 10.06 5.06 1.21 9.88-2.68 10.52-6.47.64-3.79-1.08-8.78-6.37-9.63ZM1532.21 551.56c-5.29-.85-9.07 2.29-9.89 6.04-.82 3.75.68 8.85 5.74 10.06 5.06 1.21 9.88-2.68 10.52-6.47.64-3.79-1.08-8.78-6.37-9.63ZM1695.36 551.56c-5.29-.85-9.07 2.29-9.89 6.04-.82 3.75.68 8.85 5.74 10.06 5.06 1.21 9.88-2.68 10.52-6.47.64-3.79-1.08-8.78-6.37-9.63Z"
          style={{
            fill: '#54535e',
          }}
        />
      </g>
    </svg>
  )
}

export default SchoolCorridor
